import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  permissions: null,
  token: Cookies.get('token')
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => state.user !== null,
  permissions: state => state.permissions
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.FETCH_USER_PERMISSIONS_SUCCESS] (state, { permissions }) {
    state.permissions = permissions
  },

  [types.FETCH_USER_PERMISSIONS_FAILURE] (state) {
    state.permissions = null
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null

    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser ({ dispatch, commit }) {
    try {
      const { data } = await axios.get('/api/user')

      // Reload data according to user's privileges.
      await dispatch('organizations/fetchOrganizations', null, { root: true })
      await dispatch('roles/fetchRoles', null, { root: true })
      await dispatch('users/fetchUsers', null, { root: true })
      await dispatch('auth/fetchPermissions', null, { root: true })

      commit(types.FETCH_USER_SUCCESS, { user: data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  async fetchPermissions ({ dispatch, commit }) {
    try {
      const { data } = await axios.get('/api/user/permissions')

      commit(types.FETCH_USER_PERMISSIONS_SUCCESS, { permissions: data })
    } catch (e) {
      commit(types.FETCH_USER_PERMISSIONS_FAILURE)
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/auth.js